import Input from "components/Input"
import Label from "components/Label"
import { ProfileWrapper } from "./styled"
import DateTimePicker from "components/DateTimePicker"
import { useFormik } from "formik"
import ButtonIcon from "components/ButtonIcon"
import { FaEdit, FaSave, FaTimes } from "react-icons/fa";
import { useState } from "react"
import * as Yup from "yup"
import { authError } from "errors/auth"
import { REGEX_PHONE_NUMBER } from "constants/regex"
import { authAction } from "redux/slice/authSlice"
import { useDispatch } from "react-redux"
import ShowToast from "utils/ShowToast"
import Loading from "components/Loading"

const Profile = ({ data, loading }) => {
    const [isEdit, setIsEdit] = useState(false)
    const dispatch = useDispatch()
    const initialValues = data ? {
        ...data
    } : {
        account_id: "",
        avatar: "",
        account_name: "",
        birth_day: "",
        email: "",
        full_name: "",
        phone_number: "",
        sex: "",
    }
    const formData = useFormik({
        initialValues: initialValues,
        validateOnBlur: false,
        validateOnChange: false,
        validationSchema: Yup.object({
            account_name: Yup.string().trim().required(authError.requiredAccountName).min(4, authError.invalidAccountName),
            phone_number: Yup.string().trim().required(authError.requiredPhone).matches(REGEX_PHONE_NUMBER, authError.invalidPhone),
            email: Yup.string().trim().required(authError.requiredEmail).email(authError.invalidEmail),
        }),
        onSubmit: (values, { setFieldError }) => {
            if (!loading)
                dispatch(authAction.updateAccount({ data: values, setIsEdit, setFieldError, ShowToast }))
        }
    })


    const handleExit = () => {
        setIsEdit(false)
        formData.setValues({
            ...data
        })
        formData.setErrors({})
    }

    return (
        <ProfileWrapper className="bg-grey2 p-15">
            {
                loading && <Loading />
            }
            <h1 className="text-black s-18 bb-grey-1 pb-5">Thông tin cá nhân</h1>
            <form className="px-50 py-15" onSubmit={formData.handleSubmit}>
                <div className="form-group mb-10">
                    <Label className="mb-5">Id:</Label>
                    <span className="text-red bold s-16 ml-5" >{data.account_id}</span>
                </div>
                {
                    isEdit &&
                    <div className="form-group mb-10">
                        <Label className="mb-5">Ảnh đại diện:</Label>
                        <Input
                            placeholder="Nhập ảnh đại diện"
                            name="avatar"
                            value={formData.values.avatar ?? ""}
                            isError={!!formData.errors.avatar}
                            message={formData.errors.avatar}
                            onChange={formData.handleChange}
                        />
                    </div>
                }
                <div className="form-group mb-10">
                    <Label className="mb-5">Tên tài khoản:</Label>

                    <Input
                        placeholder="Nhập tên tài khoản"
                        name="account_name"
                        readOnly={!isEdit}
                        value={formData.values.account_name ?? ""}
                        isError={!!formData.errors.account_name}
                        message={formData.errors.account_name}
                        onChange={formData.handleChange}
                    />
                </div>
                <div className="form-group mb-10">
                    <Label className="mb-5">Số điện thoại:</Label>
                    <Input
                        placeholder="Nhập số điện thoại"
                        name="phone_number"
                        readOnly={!isEdit}
                        value={formData.values.phone_number ?? ""}
                        isError={!!formData.errors.phone_number}
                        message={formData.errors.phone_number}
                        onChange={formData.handleChange}
                    />
                </div>
                <div className="form-group mb-10">
                    <Label className="mb-5">Email:</Label>
                    <Input
                        placeholder="Nhập email"
                        name="email"
                        readOnly={!isEdit}
                        value={formData.values.email ?? ""}
                        isError={!!formData.errors.email}
                        message={formData.errors.email}
                        onChange={formData.handleChange}
                    />
                </div>
                <div className="form-group mb-10">
                    <Label className="mb-5">Họ và tên:</Label>
                    <Input
                        placeholder="Nhập họ và tên"
                        name="full_name"
                        readOnly={!isEdit}
                        value={formData.values.full_name ?? ""}
                        isError={!!formData.errors.full_name}
                        message={formData.errors.full_name}
                        onChange={formData.handleChange}
                    />
                </div>
                <div className="form-group mb-10">
                    <Label className="mb-5">Giới tính:</Label>
                    <div></div>
                    <span className="mr-50">
                        <input type="radio" name="sex" checked={formData.values.sex === 0} onChange={() => isEdit && formData.setFieldValue("sex", 0)} className="input_sex" id="man" />
                        <label className="pl-10 s-16 clickable text-grey bold" htmlFor="man">Nam</label>
                    </span>
                    <span className="mr-50">
                        <input type="radio" name="sex" checked={formData.values.sex === 1} onChange={() => isEdit && formData.setFieldValue("sex", 1)} className="input_sex" id="woman" />
                        <label className="pl-10 s-16 clickable text-grey bold" htmlFor="woman">Nữ</label>
                    </span>
                    <span className="mr-50">
                        <input type="radio" name="sex" checked={formData.values.sex === 2} onChange={() => isEdit && formData.setFieldValue("sex", 2)} className="input_sex" id="other" />
                        <label className="pl-10 s-16 clickable text-grey bold" htmlFor="other">Khác</label>
                    </span>
                </div>
                <div className="form-group mb-10">
                    <Label className="mb-5">Ngày sinh:</Label>
                    <div className="date_time_input">
                        <DateTimePicker
                            dateInit={new Date(formData.values.birth_day)}
                            readOnly={!isEdit}
                            onChangeDate={(date) => formData.setFieldValue("birth_day", `${new Date(date).getFullYear()}-${new Date(date).getMonth() + 1}-${new Date(date).getDate()}`)}
                        />
                    </div>
                </div>
                <div className="flex-center mt-40">
                    {
                        !isEdit &&
                        <ButtonIcon type="button" icon={<FaEdit />} classButton="action-danger-1 btn-edit" onClick={() => setIsEdit(true)}>Chỉnh sửa</ButtonIcon>
                    }
                    {
                        isEdit &&
                        <>
                            <ButtonIcon type="submit" icon={<FaSave />} classButton="action-danger-1 btn-edit" isNa={loading}>Lưu</ButtonIcon>
                            <ButtonIcon type="button" icon={<FaTimes />} classButton="action-primary btn-edit ml-15" onClick={handleExit}>Thoát</ButtonIcon>
                        </>
                    }
                </div>
            </form>
        </ProfileWrapper>
    )
}

export default Profile